module.exports = __webpack_public_path__ + "img/property_sale_icon.e82c9219.svg";